<template>
  <div class="voting-nominations-error-message__wrapper text-body">
    Something went wrong when requesting nomination categories. Please,
    <a @click.prevent="refreshPage" href="#">refresh the page.</a>
  </div>
</template>

<script>
export default {
  name: 'VotingNominationsErrorMessage',
  methods: {
    refreshPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.voting-nominations-error-message__wrapper {
  margin-top: 32px;
}
</style>
